import { isUndefined } from 'lodash';
import type {
  GetArticleQuery_query_article_Article_tags_ArticleTag,
  GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag,
} from '../../../../__generated__/queries-web';

export type GetArticleTag = Omit<
  GetArticleQuery_query_article_Article_tags_ArticleTag_tag_Tag,
  '__typename'
> & {
  isActive?: boolean;
  order: number;
};
export const getArticleTag = ({
  id,
  isActive,
  order,
  relationId,
  title,
  type,
}: GetArticleTag): GetArticleQuery_query_article_Article_tags_ArticleTag => ({
  __typename: 'ArticleTag',
  order,
  tag: {
    __typename: 'Tag',
    ...(!isUndefined(isActive) && { isActive }),
    id,
    relationId,
    title,
    type,
    ...(!isUndefined(isActive) && { isActive }),
  },
});
